export function anchorNavGolossary() {
    const header        = $(".header");
    const headerHeight  = header.innerHeight(); 
    const prHeader      = $(".primary-header");
    const prHeaderHeight = prHeader.innerHeight() - 2; 
    const subHeader     = $('.sub-header').innerHeight();
    const stickyArea    = $(".anchor-navigation");
    const stickyNav     = $('.anchor-navigation ul');
    let lastScrollTop   = 0;
    let scrollTop;

    function sticky() {
        scrollTop = $(window).scrollTop();        
        var st = window.scrollY || document.documentElement.scrollTop;
        if (st > lastScrollTop && !stickyArea.hasClass('sticky')) {
           // downscroll code
           stickyArea.addClass('sticky');
           stickyArea.css('top', `${ prHeaderHeight }px`);
        } else if (st < lastScrollTop && stickyArea.hasClass('sticky')) {
           // upscroll code
           stickyArea.removeClass('sticky');
           stickyArea.css('top', `${ subHeader + prHeaderHeight }px`);
        } 
        lastScrollTop = st <= 0 ? 0 : st;
            
        $('[data-anchor-id]').each(function (index, section) {   
            const attr = $(section).attr('data-anchor-id');                
            const itemOffsetTop = $('[data-anchor-id="' + attr + '"]').offset().top;
            const itemHeight = $(section).outerHeight(true);
            let sliderNavItem = stickyNav.find('a[href="#' + attr + '"]').parent();
            if ((scrollTop + headerHeight + 64 >= itemOffsetTop) && (scrollTop + 64 <= itemOffsetTop + itemHeight)) {
                if (!sliderNavItem.hasClass('active')) {
                    sliderNavItem.siblings().removeClass('active');
                    sliderNavItem.addClass('active');
                    $(section).addClass('active');
                }
            } else {
                $(section).removeClass('active');
            }
        });       
    }

    if ( window.innerWidth > 1200 ) {

        $('.main-menu').hover(function(){
            stickyArea.css('z-index', '199');
        },
        function(){
            stickyArea.css('z-index', '202');
        });

        sticky();

        $(window).on("load scroll resize", function () {       
            sticky();       
        });
        
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/anchorNavGolossary.js